import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { CargoType } from 'contracts/CargoTypes';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_CARGO_TYPE_',
  }
);

export interface FetchCargoTypeState {
  data: CargoType | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchCargoTypeRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: CargoType;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchCargoTypeState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchCargoTypeState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchCargoTypeState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchCargoTypeState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchCargoTypeState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchCargoType = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchCargoTypeTypes = Types;
export const FetchCargoTypeActions = Creators;
